import { Component, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import {
  CountryDto,
  StateDto,
  LgaDto,
  CommunityDto,
  ClusterDto,
  ClusterCommunityDto,
  OilBlockDto,
  OilFieldDto,
  DocumentCategoryDto,
  DocumentSubCategoryDto,
  ProjectCategoryDto,
  ProjectTypeDto,
  CurrencyDto,
} from '@cradua/data';
import { ClusterCommunityFacade } from '../../states/+cluster-community/cluster-community.facade';
import { ClusterFacade } from '../../states/+cluster/cluster.facade';
import { CommunityFacade } from '../../states/+community/community.facade';
import { CurrencyFacade } from '../../states/+currency/currency.facade';

import { StateFacade } from '../../states/+state/state.facade';
import { CountryFacade } from '../../states/+country/country.facade';
import { ProjectTypeFacade } from '../../states/+project-type/project-type.facade';
import { ProjectCategoryFacade } from '../../states/+project-category/project-category.facade';
import { OilFieldFacade } from '../../states/+oil-field/oil-field.facade';
import { OilBlockFacade } from '../../states/+oil-block/oil-block.facade';
import { DocumentCategoryFacade } from '../../states/+document-category/document-category.facade';
import { DocumentSubCategoryFacade } from '../../states/+document-sub-category/document-sub-category.facade';
import { LgaFacade } from '../../states/+lga/lga.facade';

@Component({
  selector: 'mrsoftapps-general-reference-container',
  templateUrl: './general-reference-container.component.html',
  styleUrls: ['./general-reference-container.component.scss'],
})
export class GeneralReferenceContainerComponent implements OnInit {
  isLoadingCountry$: Observable<any>;
  isLoadingState$: Observable<any>;
  isLoadingLga$: Observable<any>;
  isLoadingCluster$: Observable<any>;
  isLoadingClusterCommunity$: Observable<any>;
  isLoadingOilBlock$: Observable<any>;
  isLoadingOilField$: Observable<any>;
  isLoadingDocumentCategory$: Observable<any>;
  isLoadingDocumentSubCategory$: Observable<any>;
  isLoadingProjectType$: Observable<any>;
  isLoadingProjectCategory$: Observable<any>;
  isLoadingCommunity$: Observable<any>;
  isLoadingCurrency$: Observable<any>;

  countries: any[];
  states: any[];
  lgas: any[];
  clusters: any[];
  clusterCommunities: any[];
  oilBlocks: any[];
  oilFields: any[];
  documentCategories: any[];
  documentSubCategories: any[];
  projectCategories: any[];
  projectTypes: any[];
  communities: any[];
  currencies: any[];

  country$: Observable<CountryDto[]>;
  state$: Observable<StateDto[]>;
  lga$: Observable<LgaDto[]>;
  community$: Observable<CommunityDto[]>;
  cluster$: Observable<ClusterDto[]>;
  clusterCommunity$: Observable<ClusterCommunityDto[]>;
  oilBlock$: Observable<OilBlockDto[]>;
  oilField$: Observable<OilFieldDto[]>;
  documentCategory$: Observable<DocumentCategoryDto[]>;
  documentSubCategory$: Observable<DocumentSubCategoryDto[]>;
  projectCategory$: Observable<ProjectCategoryDto[]>;
  projectType$: Observable<ProjectTypeDto[]>;
  currency$: Observable<CurrencyDto[]>;

  data;
  task = 'load';
  sub: Subscription;
  items = [
    { id: 'country', name: 'Country' },
    { id: 'state', name: 'State' },
    { id: 'lga', name: 'Lga' },
    { id: 'community', name: 'Community' },
    { id: 'currency', name: 'Currency' },
  ];

  constructor(
    private countryFacade: CountryFacade,
    private stateFacade: StateFacade,
    private lgaFacade: LgaFacade,
    private currencyFacade: CurrencyFacade,
    private communityFacade: CommunityFacade,
    private clusterFacade: ClusterFacade,
    private clusterCommunityFacade: ClusterCommunityFacade,
    private projectCategoryFacade: ProjectCategoryFacade,
    private projectTypeFacade: ProjectTypeFacade,
    private oilFieldFacade: OilFieldFacade,
    private oilBlockFacade: OilBlockFacade,
    private documentCategoryFacade: DocumentCategoryFacade,
    private documentSubCategoryFacade: DocumentSubCategoryFacade
  ) {}

  ngOnInit() {
    this.isLoadingCountry$ = this.countryFacade.isLoadingCountry;
    this.isLoadingState$ = this.stateFacade.isLoadingState;
    this.isLoadingLga$ = this.lgaFacade.isLoadingLga;
    this.isLoadingCommunity$ = this.communityFacade.isLoadingCommunity;
    this.isLoadingCurrency$ = this.currencyFacade.isLoadingCurrency;
    this.isLoadingCluster$ = this.clusterFacade.isLoadingCluster;
    this.isLoadingClusterCommunity$ = this.clusterCommunityFacade.isLoadingClusterCommunity;
    this.isLoadingProjectCategory$ = this.projectCategoryFacade.isLoadingProjectCategory;
    this.isLoadingProjectType$ = this.projectTypeFacade.isLoadingProjectType;
    this.isLoadingOilBlock$ = this.oilBlockFacade.isLoadingOilBlock;
    this.isLoadingOilField$ = this.oilFieldFacade.isLoadingOilField;
    this.isLoadingDocumentCategory$ = this.documentCategoryFacade.isLoadingDocumentCategory;
    this.isLoadingDocumentSubCategory$ = this.documentSubCategoryFacade.isLoadingDocumentSubCategory;

    this.country$ = this.countryFacade.loadCountry;
    this.state$ = this.stateFacade.loadState;
    this.lga$ = this.lgaFacade.loadLga;
    this.community$ = this.communityFacade.loadCommunity;
    this.currency$ = this.currencyFacade.loadCurrency;
    this.cluster$ = this.clusterFacade.loadCluster;
    this.clusterCommunity$ = this.clusterCommunityFacade.loadClusterCommunity;
    this.projectCategory$ = this.projectCategoryFacade.loadProjectCategory;
    this.projectType$ = this.projectTypeFacade.loadProjectType;
    this.oilBlock$ = this.oilBlockFacade.loadOilBlock;
    this.oilField$ = this.oilFieldFacade.loadOilField;
    this.documentCategory$ = this.documentCategoryFacade.loadDocumentCategory;
    this.documentSubCategory$ = this.documentSubCategoryFacade.loadDocumentSubCategory;

    this.subscribeReference();
  }

  subscribeReference() {
    this.sub = this.country$.subscribe((data) => {
      this.countries = data.map((item) => {
        return {
          CountryName: item.CountryName,
          CountryCode: item.CountryCode,
          id: item.id,
        };
      });
    });

    this.sub = this.state$.subscribe((data) => {
      this.states = data.map((item) => {
        return {
          StateName: item.StateName,

          CountryId: item.CountryId,
          id: item.id,
        };
      });
    });

    this.sub = this.lga$.subscribe((data) => {
      this.lgas = data.map((item) => {
        return {
          LgaName: item.LgaName,

          StateId: item.StateId,
          id: item.id,
        };
      });
    });

    this.sub = this.community$.subscribe((data) => {
      this.communities = data.map((item) => {
        return {
          CommunityName: item.CommunityName,
          SerialNo: item.SerialNo,
          LgaId: item.LgaId,
          id: item.id,
        };
      });
    });

    this.sub = this.currency$.subscribe((data) => {
      this.currencies = data.map((item) => {
        return {
          CurrencyName: item.CurrencyName,
          CurrencyCode: item.CurrencyCode,
          id: item.id,
        };
      });
    });

    this.sub = this.cluster$.subscribe((data) => {
      this.clusters = data.map((item) => {
        return {
          ClusterName: item.ClusterName,
          id: item.id,
        };
      });
    });

    this.sub = this.clusterCommunity$.subscribe((data) => {
      this.clusterCommunities = data.map((item) => {
        return {
          ClusterCommunityName: item.ClusterCommunityName,
          ClusterId: item.ClusterId,
          CommunityId: item.CommunityId,
          GMOUId: item.GMOUId,
          LgaId: item.LgaId,
          StateId: item.StateId,
          id: item.id,
        };
      });
    });

    this.sub = this.projectCategory$.subscribe((data) => {
      this.projectCategories = data.map((item) => {
        return {
          ProjectCategoryName: item.ProjectCategoryName,
          id: item.id,
        };
      });
    });

    this.sub = this.projectType$.subscribe((data) => {
      this.projectTypes = data.map((item) => {
        return {
          ProjectTypeName: item.ProjectTypeName,
          ProjectTypeId: item.ProjectTypeId,
          id: item.id,
        };
      });
    });

    this.sub = this.oilBlock$.subscribe((data) => {
      this.oilBlocks = data.map((item) => {
        return {
          OilBlockName: item.OilBlockName,
          LabelName: item.LabelName,
          id: item.id,
        };
      });
    });

    this.sub = this.oilField$.subscribe((data) => {
      this.oilFields = data.map((item) => {
        return {
          OilFieldName: item.OilFieldName,
          OilBlockId: item.OilBlockId,
          LabelName: item.LabelName,
          id: item.id,
        };
      });
    });

    this.sub = this.documentCategory$.subscribe((data) => {
      this.documentCategories = data.map((item) => {
        return {
          DocumentCategoryName: item.DocumentCategoryName,
          id: item.id,
        };
      });
    });

    this.sub = this.documentSubCategory$.subscribe((data) => {
      this.documentSubCategories = data.map((item) => {
        return {
          DocumentSubCategoryName: item.DocumentSubCategoryName,
          DocumentCategoryId: item.DocumentCategoryId,
          id: item.id,
        };
      });
    });
  }

  selectReference(event) {
    // console.log(event.value);
    this.data = event.value;
    this.task = 'reference';
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDelete(deletedValue: any[]) {
    if (deletedValue[0] === 'country') {
      deletedValue.shift();
      this.countryFacade.removeCountry(deletedValue);
    } else if (deletedValue[0] === 'state') {
      deletedValue.shift();
      this.stateFacade.removeState(deletedValue);
    } else if (deletedValue[0] === 'currency') {
      deletedValue.shift();
      this.currencyFacade.removeCurrency(deletedValue);
    } else if (deletedValue[0] === 'community') {
      deletedValue.shift();
      this.communityFacade.removeCommunity(deletedValue);
    } else if (deletedValue[0] === 'lga') {
      deletedValue.shift();
      this.lgaFacade.removeLga(deletedValue);
    } else if (deletedValue[0] === 'cluster') {
      deletedValue.shift();
      this.clusterFacade.removeCluster(deletedValue);
    } else if (deletedValue[0] === 'clusterCommunity') {
      deletedValue.shift();
      this.clusterCommunityFacade.removeClusterCommunity(deletedValue);
    } else if (deletedValue[0] === 'projectCategory') {
      deletedValue.shift();
      this.projectCategoryFacade.removeProjectCategory(deletedValue);
    } else if (deletedValue[0] === 'projectType') {
      deletedValue.shift();
      this.projectTypeFacade.removeProjectType(deletedValue);
    } else if (deletedValue[0] === 'oilBlock') {
      deletedValue.shift();
      this.oilBlockFacade.removeOilBlock(deletedValue);
    } else if (deletedValue[0] === 'oilField') {
      deletedValue.shift();
      this.oilFieldFacade.removeOilField(deletedValue);
    } else if (deletedValue[0] === 'documentCategory') {
      deletedValue.shift();
      this.documentCategoryFacade.removeDocumentCategory(deletedValue);
    } else if (deletedValue[0] === 'documentSubCategory') {
      deletedValue.shift();
      this.documentSubCategoryFacade.removeDocumentSubCategory(deletedValue);
    }
  }

  // this method control both the create and update

  onSubmitProjectRef(formValue: any) {
    if (formValue.type === 'country') {
      event.preventDefault();
      const pullData = formValue.Countries;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllCountry = [];

      // loop through the form data to check for update and create
      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllCountry.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllCountry.length !== 0) {
        this.countryFacade.addCountry(addAllCountry);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.countries, allUpdates);
      if (getChange) {
        // dispatch update data to the store
        this.countryFacade.updateCountry(allUpdates);
      }
    } else if (formValue.type === 'state') {
      event.preventDefault();
      const pullData = formValue.States;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllState = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllState.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllState.length !== 0) {
        this.stateFacade.addState(addAllState);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.states, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.stateFacade.updateState(allUpdates);
      }
    } else if (formValue.type === 'lga') {
      event.preventDefault();
      const pullData = formValue.Lgas;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllLga = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllLga.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllLga.length !== 0) {
        this.lgaFacade.addLga(addAllLga);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.lgas, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.lgaFacade.updateLga(allUpdates);
      }
    } else if (formValue.type === 'community') {
      event.preventDefault();
      const pullData = formValue.Communities;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllCommunity = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllCommunity.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllCommunity.length !== 0) {
        this.communityFacade.addCommunity(addAllCommunity);
      }
      // console.log('communite ', this.communities, allUpdates);
      // check if there is any update on the object
      const getChange = this.getChanges(this.communities, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.communityFacade.updateCommunity(allUpdates);
      }
    } else if (formValue.type === 'currency') {
      event.preventDefault();
      const pullData = formValue.Currencies;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllCurrencies = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllCurrencies.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllCurrencies.length !== 0) {
        this.currencyFacade.addCurrency(addAllCurrencies);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.currencies, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.currencyFacade.updateCurrency(allUpdates);
      }
    } else if (formValue.type === 'cluster') {
      event.preventDefault();
      const pullData = formValue.Clusters;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAlClusters = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAlClusters.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAlClusters.length !== 0) {
        this.clusterFacade.addCluster(addAlClusters);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.clusters, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.clusterFacade.updateCluster(allUpdates);
      }
    } else if (formValue.type === 'clusterCommunity') {
      event.preventDefault();
      const pullData = formValue;
      console.log('fetch ', pullData);
      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAlClusterCommunities = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAlClusterCommunities.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAlClusterCommunities.length !== 0) {
        this.clusterCommunityFacade.addClusterCommunity(
          addAlClusterCommunities
        );
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.clusterCommunities, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.clusterCommunityFacade.updateClusterCommunity(allUpdates);
      }
    } else if (formValue.type === 'oilBlock') {
      event.preventDefault();
      const pullData = formValue.OilBlocks;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllOilBlocks = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllOilBlocks.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllOilBlocks.length !== 0) {
        this.oilBlockFacade.addOilBlock(addAllOilBlocks);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.oilBlocks, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.oilBlockFacade.updateOilBlock(allUpdates);
      }
    } else if (formValue.type === 'oilField') {
      event.preventDefault();
      const pullData = formValue.OilFields;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllOilFields = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllOilFields.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllOilFields.length !== 0) {
        this.oilFieldFacade.addOilField(addAllOilFields);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.oilFields, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.oilFieldFacade.updateOilField(allUpdates);
      }
    } else if (formValue.type === 'projectCategory') {
      event.preventDefault();
      const pullData = formValue.ProjectCategories;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllProjectCategories = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllProjectCategories.push(pullData[i]);
        }
      }
      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllProjectCategories.length !== 0) {
        this.projectCategoryFacade.addProjectCategory(addAllProjectCategories);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.projectCategories, allUpdates);

      if (getChange) {
        // dispatch update data to the store
        this.projectCategoryFacade.updateProjectCategory(allUpdates);
      }
    } else if (formValue.type === 'projectType') {
      event.preventDefault();
      const pullData = formValue.ProjectTypes;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllProjectType = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllProjectType.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllProjectType.length !== 0) {
        this.projectTypeFacade.addProjectType(addAllProjectType);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.projectTypes, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.projectTypeFacade.updateProjectType(allUpdates);
      }
    } else if (formValue.type === 'documentCategory') {
      event.preventDefault();
      const pullData = formValue.DocumentCategories;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllDocumentCategory = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllDocumentCategory.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllDocumentCategory.length !== 0) {
        this.documentCategoryFacade.addDocumentCategory(addAllDocumentCategory);
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.documentCategories, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.documentCategoryFacade.updateDocumentCategory(allUpdates);
      }
    } else if (formValue.type === 'documentSubCategory') {
      event.preventDefault();
      const pullData = formValue.DocumentSubCategories;

      // declare two empty array to hold update and create data
      let allUpdates = [];
      let addAllDocumentSubCategory = [];

      // loop through the form data to check for update and create

      for (let i = 0; i < pullData.length; i++) {
        if (pullData[i].id !== null) {
          allUpdates.push(pullData[i]);
        } else {
          addAllDocumentSubCategory.push(pullData[i]);
        }
      }

      // check if the addAllCountry array is not empty, then dispatch the data to the store
      if (addAllDocumentSubCategory.length !== 0) {
        this.documentSubCategoryFacade.addDocumentSubCategory(
          addAllDocumentSubCategory
        );
      }

      // check if there is any update on the object
      const getChange = this.getChanges(this.documentSubCategories, allUpdates);

      // console.log('changed value ', getChange);
      if (getChange) {
        // dispatch update data to the store
        this.documentSubCategoryFacade.updateDocumentSubCategory(allUpdates);
      }
    }
  }

  getChanges(oldArray, newArray) {
    let changes, i, item, j, len;
    if (JSON.stringify(oldArray) === JSON.stringify(newArray)) {
      return false;
    }
    changes = [];
    for (i = j = 0, len = newArray.length; j < len; i = ++j) {
      item = newArray[i];
      if (JSON.stringify(item) !== JSON.stringify(oldArray[i])) {
        changes.push(item);
      }
    }
    return changes;
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
